import React, { useEffect, useState } from 'react';
import axios from 'axios';

import './App.css';
import CoursePlayer from './components/CoursePlayer/CoursePlayer';
import Spinner from './components/CoursePlayer/UI/Spinner/Spinner';

function App() {
  const [course, setCourse] = useState({});
  const [isFetching, setIsFetching] = useState(true);

  useEffect(() => {
    async function fetchCourse() {
      const res = await axios.get(`data/course.json`);
      if (!res.data) return;
      setCourse(res.data);
      setIsFetching(false);
    }
    fetchCourse();
  }, []);

  if (isFetching) return <Spinner />;

  return (
    <div className="App">
      <CoursePlayer
        course={course}
        // @ts-ignore
        customLabels={course?.customLabels}
      />
    </div>
  );
}

export default App;
